export default "__VITE_ASSET__j7qW3xZq__"